"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_backspace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dda5ae69-25c0-4ac9-845e-53eb799969de",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "backspace-hi"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88,86.88,45.21,45.39A11.6,11.6,0,0,1,55,40H160.74a15.5,15.5,0,0,1,15.51,15.51v80.85a15.5,15.5,0,0,1-15.51,15.5H55a11.62,11.62,0,0,1-9.8-5.38L18.88,105A16.89,16.89,0,0,1,18.88,86.88Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.74,149.93H55a11.6,11.6,0,0,1-9.8-5.38l-26.33-41.5A16.77,16.77,0,0,1,16.28,95a16.91,16.91,0,0,0,2.6,10l26.33,41.49a11.6,11.6,0,0,0,9.8,5.38H160.74a15.5,15.5,0,0,0,15.51-15.5v-1.93A15.5,15.5,0,0,1,160.74,149.93Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,95.75l22.81-22.82a2,2,0,0,0-2.86-2.86L109.58,92.88,86.76,70.07a2,2,0,0,0-2.86,2.86l22.81,22.82L83.9,118.57a2,2,0,1,0,2.86,2.86l22.82-22.81,22.82,22.81a2,2,0,0,0,2.86,0,2,2,0,0,0,0-2.86Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }));
}

var _default = ic_backspace;
exports.default = _default;